<template>
    <component :is="currentComponent" />
</template>

<script>
import XiHome from '@/components/showcase/home/XiHome'
import KocomHome from '@/components/showcase/home/KocomHome'
import SoldocHome from '@/components/showcase/home/SoldocHome'
import SeoulOneHome from '@/components/showcase/home/SeoulOneHome'
import LynnHome from '@/components/showcase/home/LynnHome'
import Bodyfriend from '@/components/showcase/home/Bodyfriend'

export default {
    name: 'home',
    components: {
        XiHome,
        KocomHome,
        SoldocHome,
        SeoulOneHome,
        LynnHome,
        Bodyfriend
    },
    computed: {
        currentComponent: function() {
            const componentMap = {
                xi: 'XiHome',
                kocom: 'KocomHome',
                soldoc: 'SoldocHome',
                seoulone: 'SeoulOneHome',
                lynn: 'LynnHome',
                bodyfriend: 'Bodyfriend'
            }
            return componentMap[this.$route.params.showcase] || 'XiHome'
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/page/showcase/Home.vue